import React, { useEffect, useRef, useState } from "react";
import "../../styles/components/CaseArticle.css";
import Modal from "../../components/Modal";
import ContactFormSimple from "../../components/ContactFormSimple";
import arrowCircle from "../../img/hero/arrow-circle-2.png";
import cloudsImage from "../../img/cases/case-clouds-3.webp";

/* тимчасові картинки для What We Built */
import builtPhone1 from "../../img/cases/drsl-phone-3.webp";
import builtIcon1 from "../../img/cases/built-icon-1.png";
import builtPhone2 from "../../img/cases/drsl-phone-4.webp";
import builtIcon2 from "../../img/cases/built-icon-2.png";
import builtPhone3 from "../../img/cases/drsl-phone-5.webp";
import builtIcon3 from "../../img/cases/built-icon-3.png";
import builtPhone4 from "../../img/cases/drsl-phone-6.webp";
import builtIcon4 from "../../img/cases/built-icon-4.png";
import builtPhone5 from "../../img/cases/drsl-phone-7.webp";
import builtIcon5 from "../../img/cases/built-icon-5.png";
import builtPhone6 from "../../img/cases/drsl-phone-8.webp";
import builtIcon6 from "../../img/cases/built-icon-6.png";
import builtPhone7 from "../../img/cases/drsl-phone-9.webp";
import builtIcon7 from "../../img/cases/built-icon-1.png";
import builtPhone8 from "../../img/cases/drsl-phone-10.webp";
import builtIcon8 from "../../img/cases/built-icon-7.png";
import builtPhone9 from "../../img/cases/drsl-phone-11.webp";
import builtIcon9 from "../../img/cases/built-icon-8.png";

import stackIcon1 from "../../img/cases/stack-icon-1.png";
import stackIcon2 from "../../img/cases/stack-icon-2.png";
import stackIcon3 from "../../img/cases/stack-icon-3.png";
import stackIcon4 from "../../img/cases/stack-icon-4.png";
import stackIcon5 from "../../img/cases/stack-icon-5.png";
import stackIcon6 from "../../img/cases/stack-icon-6.png";
import stackIcon7 from "../../img/cases/stack-icon-7.png";
import stackIcon8 from "../../img/cases/stack-icon-8.png";

import IconPng from "../IconPng";

import resultsBg1 from "../../img/cases/results-bg-1.png";
import resultsBg2 from "../../img/cases/results-bg-2.png";


const sections = [
  {
    id: "about",
    title: "About the Project",
    text: [
      "Dressly AI is a virtual try-on platform where users digitally “wear” clothing with photorealistic results. Our task — build and continuously evolve the AI backbone that makes this possible at scale for millions of users.",
    ],
  },
  {
    id: "challenge",
    title: "The Challenge",
    text: [
      "The initial system was built on early OpenAI image editing capabilities — before the market had reliable face preservation, generation consistency, or quality garment rendering. Results were unstable: identity loss, visual artifacts, garments drawn incorrectly. For a fashion product, this directly killed retention and user trust.",
      "The core engineering problem: even state-of-the-art cloud models don't produce stable try-on results out of the box. Making them reliable required building an entire layer of control and quality assurance on top.",
    ],
  },
  {
    id: "goal",
    title: "The Goal",
    text: [
      "Achieve stable, predictable try-on quality at scale. Improve retention and user satisfaction through a fundamentally better AI experience.",
    ],
  },
];

const builtCards = [
  {
    id: "built-1",
    variant: "double",
    title: "STABILIZED VIRTUAL TRY-ON PIPELINE",
    text:
      "Integrated leading cloud-based models (Banana, Seedream) and built additional AI flows on top to track consistency, catch artifacts, and ensure output quality. The hardest part — making closed-source models behave reliably across thousands of different body types, poses, and garments.",
    icon: builtIcon1,
    image: builtPhone1,
  },

  {
    id: "built-2",
    variant: "double",
    title: "Identity Preservation System",
    text:
      "Implemented segmentation (SAM3) and control flows that ensure the user's face, body, and proportions stay intact after garment rendering.",
    icon: builtIcon2,
    image: builtPhone2,
  },

  {
    id: "built-3",
    variant: "single",
    title: "Multimodal AI Search",
    text:
      "Built natively multimodal search using Pinecone and Elasticsearch, which improved both the RAG pipeline for the AI agent and enabled new user-facing discovery experiences.",
    icon: builtIcon3,
    image: builtPhone3,
  },

  {
    id: "built-4",
    variant: "double",
    title: "Agentic AI Pipelines",
    text:
      "LangChain-based agentic flows for internal quality control and automated processing — plus an ongoing user-facing fashion agent (in development)",
    icon: builtIcon4,
    image: builtPhone4,
  },

  {
    id: "built-5",
    variant: "single",
    title: "User preference management",
    text:
      "Architectured a multi-endpoint subsystem for collecting, storing, and managing individual user preferences, providing contextual insights to various application services.",
    icon: builtIcon5,
    image: builtPhone5,
  },

  {
    id: "built-6",
    variant: "single",
    title: "AI-assisted evaluation",
    text:
      "Established multiple LLM-as-a-judge pipelines for automatic VTON quality evaluation.",
    icon: builtIcon6,
    image: builtPhone6,
  },

  {
    id: "built-7",
    variant: "double",
    title: "Advanced Segmentation",
    text:
      "Set up multi-purpose model services, achieving segmentation metrics on par with global competitors.",
    icon: builtIcon7,
    image: builtPhone7,
  },

  {
    id: "built-8",
    variant: "single",
    title: "AI Capsule & Wardrobe Intelligence",
    text:
      "Built an agentic pipeline (LangGraph / LangChain) that turns rich user preference signals and real catalog data into structured “capsule” wardrobes — complete with rule-aware assembly, automated quality evaluation, and production-ready exports. Wired RAG and LLM-as-a-judge to remove hallucinations and ensure business rules are followed.",
    icon: builtIcon8,
    image: builtPhone8,
  },

  {
    id: "built-9",
    variant: "single",
    title: "Advanced Recommendation System.",
    text:
      "Implemented a multi-model recommendation system encompassing users’ behaviour signals, creating a unique and personalized app experience.",
    icon: builtIcon9,
    image: builtPhone9,
  },
];

const techStack = [
  {
    title: "LangChain/LangGraph",
    icon: stackIcon1,
    size: "wide",
  },
  {
    title: "Nano Banana",
    icon: stackIcon2,
    size: "medium",
  },
  {
    title: "Qwen",
    icon: stackIcon3,
    size: "small",
  },
  {
    title: "Seedream",
    icon: stackIcon4,
    size: "medium",
  },
  {
    title: "Pinecone",
    icon: stackIcon5,
    size: "small",
  },
  {
    title: "Elasticsearch",
    icon: stackIcon6,
    size: "medium",
    iconSize: "large" // 👈 додали
  },
  {
    title: "SAM3",
    icon: stackIcon7,
    size: "small",
  },
  {
    title: "ML-powered RecSys models",
    icon: stackIcon8,
    size: "large",
  },
];

const resultsCards = [
  {
    variant: "small",
    icons: ["Robot-2", "UsersThree-2"],
    title: "10M+ MAU",
  },
  {
    variant: "soft",
    icons: ["ArrowsClockwise-2", "ChartLineUp-2"],
    text:
      "Retention and app store ratings significantly improved after AI pipeline overhaul",
    bg: resultsBg1,
  },
  {
    variant: "wide",
    icons: ["Infinity-2", "Graph-2"],
    text:
      "Project ongoing — currently building internal AI agentic pipelines and expanding the fashion agent experience",
  },
  {
    variant: "tall",
    icons: ["GitBranch-2", "ShieldCheck-2"],
    text:
      "Stable, consistent try-on quality across diverse user inputs",
    bg: resultsBg2,
  },
];

const beforeAfterCards = [
  {
    variant: "before",
    title: "Before",
    text:
      "Static chatbot with no memory. No awareness of user progress, mood, or history. Fragmented, impersonal experience.",
  },
  {
    variant: "after",
    title: "After",
    text:
      "AI mentor that remembers, learns, and evolves with each user. Structured memory with conflict resolution, intelligent context assembly, and personalization that deepens over time.",
  },
];

const navItems = [
  ["about", "About the Project"],
  ["challenge", "The Challenge"],
  ["goal", "The Goal"],
  ["built", "What We Built"],
  ["key", "Key Challenge"],
  ["stack", "Tech Stack"],
  ["results", "Results"],
  ["before", "Before / After"],
  ["unique", "What Makes It Unique"],
];



export default function CaseArticleDrsl() {
  const [activeId, setActiveId] = useState("about");
  const [openModal, setOpenModal] = useState(false);
  const isManualScrolling = useRef(false);
  const scrollTimer = useRef(null);

  useEffect(() => {
    const elements = navItems
      .map(([id]) => document.getElementById(id))
      .filter(Boolean);

    const observer = new IntersectionObserver(
      (entries) => {
        const visibleEntries = entries.filter((entry) => entry.isIntersecting);

        if (visibleEntries.length > 0) {
          if (isManualScrolling.current) return;
          const closest = visibleEntries.sort(
            (a, b) => a.boundingClientRect.top - b.boundingClientRect.top
          )[0];



          setActiveId(closest.target.id);
        }
      },
      {
        root: null,
        rootMargin: "-25% 0px -60% 0px",
        threshold: 0,
      }
    );

    elements.forEach((el) => observer.observe(el));

    return () => observer.disconnect();
  }, []);

  useEffect(() => {
    const items = document.querySelectorAll(".case-reveal-right");

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("is-visible");
          }
        });
      },
      {
        threshold: 0.12,
        rootMargin: "0px 0px -80px 0px",
      }
    );

    items.forEach((item) => observer.observe(item));

    return () => observer.disconnect();
  }, []);

  const handleNavClick = (e, id) => {
    e.preventDefault();

    isManualScrolling.current = true;
    setActiveId(id);

    const section = document.getElementById(id);

    if (section) {
      section.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }

    clearTimeout(scrollTimer.current);

    scrollTimer.current = setTimeout(() => {
      isManualScrolling.current = false;
    }, 900);
  };

  return (
    <section className="case-article">
      <aside className="case-article__sidebar">
        <div className="case-article__toc">
          <h3>Contents</h3>

          <nav>
            {navItems.map(([id, label], index) => (
              <a
                key={id}
                href={`#${id}`}
                onClick={(e) => handleNavClick(e, id)}
                className={
                  activeId === id
                    ? "case-article__toc-link active"
                    : "case-article__toc-link"
                }
              >
                <span className="case-article__toc-line" />
                <span className="case-article__toc-number">{index + 1}</span>
                <span className="case-article__toc-label">{label}</span>
              </a>
            ))}
          </nav>
        </div>

        <div className="case-article__cta">
          <h3>
            Ready to make your product
            <br />
            personal? Let’s talk!
          </h3>

          <button
            type="button"
            className="case-article__cta-btn"
            onClick={() => setOpenModal(true)}
          >
            <span>Contact Us</span>
            <img src={arrowCircle} alt="" aria-hidden="true" />
          </button>

          <img
            className="case-article__cta-clouds"
            src={cloudsImage}
            alt=""
            aria-hidden="true"
          />
        </div>
      </aside>

      <div className="case-article__content">
        {sections.map((section) => (
          <section
            key={section.id}
            id={section.id}
            className="case-article__section case-reveal-right"
          >
            <h2>{section.title}</h2>

            {section.text.map((paragraph, index) => (
              <p key={index}>{paragraph}</p>
            ))}
          </section>
        ))}

        <section id="built" className="case-article__section">
          <h2>What We Built</h2>

          <div className="case-built-list">
            {builtCards.map((card) => (
              <article
                className={`case-built-card case-built-card--${card.variant} case-reveal-right`}
                key={card.id}
              >
                <img
                  className="case-built-card__icon"
                  src={card.icon}
                  alt=""
                  aria-hidden="true"
                />

                <div className="case-built-card__text">
                  <h3>{card.title}</h3>
                  <p>{card.text}</p>
                </div>

                <img
                  className="case-built-card__image"
                  src={card.image}
                  alt=""
                />
              </article>
            ))}
          </div>
        </section>
        <section id="key" className="case-article__section case-reveal-right">
          <h2>Key Challenge</h2>

          <p>
            Getting SOTA results from closed-source models was the biggest technical
            hurdle. These models produce impressive outputs in demos, but behave
            unpredictably at scale — inconsistent garment fit, identity drift between
            generations, and random artifacts.
          </p>

          <p>
            Our approach: we built additional AI control flows that monitor output
            consistency, enhanced prompting strategies, and continuously researched and
            swapped in the best available models as the market evolved. The result is a
            stabilization layer that turns unpredictable model outputs into a reliable
            product experience.
          </p>
        </section>
        <section id="stack" className="case-article__section case-reveal-right">
          <div className="case-stack">

            <h2 className="case-stack__title">Tech Stack</h2>

            <div className="case-stack__grid">
              {techStack.map((item) => (
                <div
                  key={item.title}
                  className={`case-stack__card ${item.size || ""}`}
                >
                  <img
                    src={item.icon}
                    alt=""
                    className={item.iconSize || ""}
                  />
                  <span>{item.title}</span>
                </div>
              ))}
            </div>

          </div>
        </section>

        <section id="results" className="case-article__section case-reveal-right">
          <h2>Results</h2>

          <div className="case-results">
            {resultsCards.map((card, index) => (
              <article
                key={index}
                className={`case-results__card case-results__card--${card.variant}`}
              >
                {card.bg && (
                  <img
                    className="case-results__bg"
                    src={card.bg}
                    alt=""
                    aria-hidden="true"
                  />
                )}

                <div className="case-results__icons">
                  {card.icons.map((icon) => (
                    <span className="case-results__icon" key={icon}>
                      <IconPng name={icon} size={28} />
                    </span>
                  ))}
                </div>

                {card.title && <h3>{card.title}</h3>}
                {card.text && <p>{card.text}</p>}
              </article>
            ))}
          </div>
        </section>

        <section id="before" className="case-article__section case-reveal-right">
          <div className="case-before-after">
            {beforeAfterCards.map((card) => (
              <article
                key={card.variant}
                className={`case-before-after__card case-before-after__card--${card.variant}`}
              >
                <h2>{card.title}</h2>
                <p>{card.text}</p>
              </article>
            ))}
          </div>
        </section>

        <section id="unique" className="case-article__section case-reveal-right">
          <h2>What Makes It Unique</h2>

          <p>
            Not a chatbot with a prompt — a full memory and context architecture built
            for long-term personal relationships at scale. The multi-layer memory system
            with automated lifecycle management, the intelligent context assembly that
            fits rich user data into LLM constraints, and the content variation handling
            create an AI that behaves like a real mentor: it remembers what matters,
            forgets what doesn’t, and gets better with every conversation.
          </p>
        </section>

      </div>
      <Modal
        open={openModal}
        onClose={() => setOpenModal(false)}
        title="Start your project"
      >
        <ContactFormSimple onSubmit={() => setOpenModal(false)} />
      </Modal>
    </section>
  );
}
